import axios from 'axios';

import { store } from "../store";
import { TokenService } from "../services/storage.service";
import { API_BASE_URL, DEFAULT_BEARER_TOKEN } from "../constants";
import { alertActions, donationActions } from "../store/actions";

const customAxios = axios.create({
    baseURL: API_BASE_URL,
});

const requestHandler = request => {
    if (request.useDefaultToken) {
        request.headers.Authorization = DEFAULT_BEARER_TOKEN;
        return request;
    }
    
    let token;
    if (TokenService.tokenExist()) {
        token = TokenService.getToken();
        request.headers.Authorization = `Bearer ${token}`;
    }
    else request.headers.Authorization = DEFAULT_BEARER_TOKEN;

    return request;
};

const responseHandler = response => {
    return response;
};

const errorHandler = error => {
    if (error.response?.status == 500) {
        store.dispatch(donationActions.updateLoaderState(false));
        store.dispatch(alertActions.error("Something went wrong, please try again later."))
    }
    return Promise.reject(error);
};

customAxios.interceptors.request.use(
    (request) => requestHandler(request),
    (error) => errorHandler(error)
);

customAxios.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => errorHandler(error)
);

export default customAxios;